import { defineStore } from "pinia";

import api from "@/api";
import { useUserStore } from "./user";

export const useTeamStore = defineStore("team", {
  state: () => ({
    allDict: {},
    validDict: {},
    loading: false,
    dropdownOptions: [],
  }),
  getters: {
    validList: (state) => Object.values(state.validDict),
    userIds: (state) => (id) => state.validDict[id]?.users || []
  },
  actions: {
    async fetchAll() {
      try {
        this.loading = true;
        const userStore = useUserStore()
        const organization_id = userStore.authUserOrganizationId
        const teams = await api.team.fetchAll(organization_id);
        this.allDict = {};
        this.validDict = {};

        for (const team of teams) {
          this.allDict[team._id] = team;
          if (!team.is_deleted) {
            this.validDict[team._id] = team;
          }
        }
        // filter out any teams that are is_deleted = true
        this.dropdownOptions = Object.values(this.allDict)
          .filter(team => !team.is_deleted)
          .map(({ _id, name }) => {
            return { value: _id, text: name || "N/A" };
          });

      } catch (error) {
        console.error(error.message);
      } finally {
        this.loading = false;
      }
    },
    getUserTeams(userId) {
      const res = [];
      for (let team of Object.values(this.allDict)) {
        if (team.users.includes(userId)) {
          res.push(team);
        }
      }

      return res
    }
  },
});
